import React from 'react';
import { Link } from 'react-router-dom';
import Text from '../components/Text/Text';
import ProfileNotificationSettings from '../components/ProfileNotificationSettings/ProfileNotificationSettings';
import './ProfileNotificationSettingsScreen.css';

const ProfileNotificationSettingsScreen: React.FC = () => {
  return (
    <div className="profile-notification-settings-screen">
      <div className="breadcrumb">
        <Link to="/profile" className="breadcrumb-link">
          Profile
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Notification Settings</span>
      </div>
      
      <div className="screen-header">
        <Text className="text-h2">Notification Settings</Text>
        <div>
            <Text className="text-caption">
                Manage how and when you receive notifications from VeriPay
            </Text>
        </div>
      </div>
      
      <ProfileNotificationSettings />
    </div>
  );
};

export default ProfileNotificationSettingsScreen;